// Elegir con qué app ir (29-oct-2026): Google Maps o Waze en todos los botones de "Mapa", "GPS" y
// "Cómo llegar". Los links a Google Maps de la app se interceptan (ui/ElegirNavegacion) y se ofrecen las dos.
// Waze no acepta varias paradas: en una ruta, lleva a la primera.

/** Abre el selector para ir a un lugar. */
export function irA({ direccion = null, lat = null, lng = null, nombre = null }) {
    window.dispatchEvent(new CustomEvent('elegir-navegacion', { detail: { direccion, lat, lng, nombre } }));
}

const COORD = /^\s*(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)\s*$/;

/** De un link de Google Maps: { google, waze, paradas, destino } o null si no es un link de Maps. */
export function desdeLinkGoogle(href) {
    let u;
    try { u = new URL(href); } catch { return null; }
    if (!/(^|\.)google\.[a-z.]+$/.test(u.hostname) || !u.pathname.startsWith('/maps')) return null;
    const q = u.searchParams.get('destination') || u.searchParams.get('query');
    if (!q) return null;
    const intermedias = (u.searchParams.get('waypoints') || '').split('|').filter(Boolean);
    const primera = intermedias[0] || q;
    return { google: href, waze: linkWazeDe(primera), paradas: intermedias.length + 1, destino: primera };
}

export function linkWazeDe(texto, lat = null, lng = null) {
    const c = lat != null && lng != null ? [lat, lng] : (COORD.exec(String(texto || '')) || []).slice(1);
    if (c.length === 2 && c[0] != null) return `https://waze.com/ul?ll=${c[0]},${c[1]}&navigate=yes`;
    const t = String(texto || '');
    return `https://waze.com/ul?q=${encodeURIComponent(/argentina/i.test(t) ? t : `${t}, Buenos Aires, Argentina`)}&navigate=yes`;
}

export function linkGoogleDe(texto, lat = null, lng = null) {
    return lat != null && lng != null
        ? `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`
        : `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(String(texto || ''))}`;
}
